import { relations } from "drizzle-orm/_relations";
import {
  boolean,
  index,
  integer,
  pgTable,
  serial,
  text,
  timestamp,
  unique,
  uuid,
} from "drizzle-orm/pg-core";
import { createSchemaFactory } from "drizzle-zod";
import { z } from "zod";

import { poolMatches } from "./pool-matches";
import { poolTeams } from "./pool-teams";
import { tournamentDivisions } from "./tournament-divisions";

const { createInsertSchema, createSelectSchema, createUpdateSchema } =
  createSchemaFactory({ zodInstance: z });

export const pools = pgTable(
  "pools",
  {
    id: serial().primaryKey(),
    name: text().notNull(),
    tournamentDivisionId: integer()
      .notNull()
      .references(() => tournamentDivisions.id, { onDelete: "cascade" }),
    court: text(),
    done: boolean().notNull().default(false),
    completedAt: timestamp(),
    externalRef: uuid().unique(),
  },
  (table) => [
    unique("pool_tournament_division_name_unique").on(
      table.tournamentDivisionId,
      table.name,
    ),
    index("pools_tournament_division_idx").on(table.tournamentDivisionId),
  ],
);

export const selectPoolSchema = createSelectSchema(pools);
export const createPoolSchema = createInsertSchema(pools).omit({
  id: true,
});
export const updatePoolSchema = createUpdateSchema(pools);

export type Pool = z.infer<typeof selectPoolSchema>;
export type CreatePool = z.infer<typeof createPoolSchema>;
export type UpdatePool = z.infer<typeof updatePoolSchema>;

export const poolRelations = relations(pools, ({ one, many }) => ({
  tournamentDivision: one(tournamentDivisions, {
    fields: [pools.tournamentDivisionId],
    references: [tournamentDivisions.id],
  }),
  teams: many(poolTeams),
  matches: many(poolMatches),
}));
